export default __webpack_public_path__ + "static/media/hero-level-1-chars-desk.ad4f75d9.webp";